<!-- 官网首页 -->
<template>
  <div class="box">
    <!-- 头部 -->
    <div class="header">
      <div class="headerContent">
        <div class="left">
          <img src="..\assets\img\logo.png" alt="">
          烟雨佳人
        </div>
        <div class="right">
          <button @click="$router.push('/download')">下载客户端</button>
          <button style="margin-left:15px" @click="$router.push('/contactUs')">联系我们</button>
        </div>
      </div>
    </div>
    <!-- 主体 -->
    <div class="main">
      <!-- 下载区域 -->
      <div class="download">
        <div class="leftImg"> </div>
        <div class="text">
          <h1 style="margin-top:30px;color: #eee">烟雨佳人 轻奢社交</h1>
          <div style="color:#958a99;margin: 15px 0;color: #eee; text-indent: 32px;">
            追求高端品质生活的你一定要有高端品质的社交圈。世界动态会每天向你推荐精彩、高端品质的Lifestyle和那个TA，享受着高端品质Lifestyle的同时也不能忘记脱单。如果刚好有你喜欢的TA，那么邀请TA来一场说走就走旅行、约会。享受的同时千万别忘了分享你自己的高端品质Lifestyle。
          </div>
          <div class="downloadBox">
            <div class="downloadButton">
              <button style="margin-bottom: 20px" @click="$router.push('/download')">
                <svg t="1614335636304" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="5683" width="20" height="20"
                  style="vertical-align: text-bottom;">
                  <path
                    d="M791.488 544.095c-1.28-129.695 105.76-191.871 110.528-194.975-60.16-88.032-153.856-100.064-187.232-101.472-79.744-8.064-155.584 46.944-196.064 46.944-40.352 0-102.816-45.76-168.96-44.544-86.912 1.28-167.072 50.528-211.808 128.384-90.304 156.703-23.136 388.831 64.896 515.935 43.008 62.208 94.304 132.064 161.632 129.568 64.832-2.592 89.376-41.952 167.744-41.952s100.416 41.952 169.056 40.672c69.76-1.312 113.984-63.392 156.704-125.792 49.376-72.16 69.728-142.048 70.912-145.632-1.536-0.704-136.064-52.224-137.408-207.136zM662.56 163.52C698.304 120.16 722.432 60 715.84 0c-51.488 2.112-113.888 34.304-150.816 77.536-33.152 38.368-62.144 99.616-54.368 158.432 57.472 4.48 116.128-29.216 151.904-72.448z"
                    p-id="5684"></path>
                </svg>
                苹果客户端下载</button>
              <button @click="$router.push('/download')">
                <svg t="1614335502792" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="3901" width="20" height="20"
                  style="vertical-align: text-bottom;">
                  <path
                    d="M639.872128 214.825175l0-43.945388-41.942058 0 0 43.945388 41.942058 0zM426.06993 214.825175l0-43.945388-41.942058 0 0 43.945388 41.942058 0zM661.866134 92.920413q105.878122 75.91342 105.878122 205.788878l-511.488511 0q0-131.878788 103.917416-205.788878l-55.965368-55.965368q-15.984016-15.984016 0-29.964702t29.964702 0l63.936064 63.936064q51.958708-27.961372 113.891442-27.961372 59.929404 0 111.888112 27.961372l63.936064-63.936064q15.984016-13.980686 29.964702 0t0 29.964702zM873.622378 342.697303q25.958042 0 44.968365 18.967699t18.967699 44.968365l0 297.686314q0 27.961372-18.967699 45.948718t-44.968365 17.987346-44.968365-17.987346-18.967699-45.948718l0-297.686314q0-25.958042 18.967699-44.968365t44.968365-18.967699zM150.377622 342.697303q25.958042 0 44.968365 18.967699t18.967699 44.968365l0 297.686314q0 27.961372-18.967699 45.948718t-44.968365 17.987346-44.968365-17.987346-18.967699-45.948718l0-297.686314q0-25.958042 18.967699-44.968365t44.968365-18.967699zM256.255744 768.255744l0-425.558442 511.488511 0 0 425.558442q0 17.987346-11.977356 29.964702t-29.964702 11.977356l-43.945388 0 0 149.866134q0 27.961372-18.967699 45.948718t-44.968365 17.987346-44.968365-17.987346-18.967699-45.948718l0-149.866134-83.92674 0 0 149.866134q0 27.961372-18.967699 45.948718t-44.968365 17.987346-44.968365-17.987346-18.967699-45.948718l0-149.866134-43.945388 0q-17.987346 0-29.964702-11.977356t-11.977356-29.964702z"
                    p-id="3902"></path>
                </svg>
                安卓客户端下载</button>
            </div>
            <div style="float:left;text-align: center;color: #eee;margin-top: 40px">
              <!-- 二维码 -->
              <div id="qrcode"></div>
              手机扫码下载
            </div>
          </div>
        </div>
      </div>
      <!-- 轮播图区域 -->
      <div class="carousel" @mouseenter="autoRollingFlag=false" @mouseleave="autoRollingFlag=true">
        <div class="left" style="float:left">
          <div @click="rolling( null,0)" :class="currentCarouselIndex == 0 ?'actvie':''" style="margin-top: 40px;">
            <p>世界动态</p>
            <p>随时随地分享生活乐趣</p>
          </div>
          <div @click="rolling(null,1)" :class="currentCarouselIndex == 1 ?'actvie':''" style="margin-top: 120px;">
            <p>同城附近推荐</p>
            <p>遇见你的心动</p>
          </div>
          <div @click="rolling(null,2)" :class="currentCarouselIndex == 2 ?'actvie':''" style="margin-top: 120px;">
            <p>资料主页</p>
            <p>多面展示你的独特</p>
          </div>
        </div>
        <!-- 轮播图 -->
        <div class="center">
          <div @click="rolling($event)" id="0" style="z-index: 10;">
          </div>
          <div @click="rolling($event)" id="1" style="transform: translateX(100px) scale(0.8);z-index: 9;">
          </div>
          <div @click="rolling($event)" id="2" style="transform: translateX(170px) scale(0.5);z-index: 8;"></div>
          <div @click="rolling($event)" id="3" style="transform: translateX(-170px) scale(0.5);z-index: 8;">
          </div>
          <div @click="rolling($event)" id="4" style="transform: translateX(-100px) scale(0.8);z-index: 9;">
          </div>
        </div>
        <div class="right" style="float:right">
          <div @click="rolling(null,3)" :class="currentCarouselIndex == 3 ?'actvie':''" style="margin-top: 40px;">
            <p>趣味聊天</p>
            <p>遇见懂你的人</p>
          </div>
          <div @click="rolling(null,4)" :class="currentCarouselIndex == 4 ?'actvie':''" style="margin-top: 120px;">
            <p>个人中心</p>
            <p>信息展示多样化</p>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="food">
        <p>2020-2021 © All Rights Reserved. 烟雨佳人APP&nbsp;&nbsp;湘ICP备2022026309号</p>
        <p>违法和不良信息举报邮箱：yyjrapp@163.com</p>
        <p><img src="..\assets\img\beianIcon.png" alt="" style="vertical-align: middle;"><a style="color: #b0aab3;"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21010402000369" target="_blank"
            rel="noopener noreferrer"> @百星文化</a></p>
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件 (比如：组件，工具js，第三方插件js，json文件，图片文件等等)
  // 例如：import 《组件名称》 from '《组件路径》'
  import QRCode from "qrcodejs2"; // 引入qrcode
  export default {
    name: "index",
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      // 这里存放数据
      return {
        // 二维码实例
        qrcode: null,
        // 轮播图样式
        styleArr: [
          'transform: translateX(-170px) scale(0.5);z-index: 8;',
          'transform: translateX(-100px) scale(0.8);z-index: 9;',
          'transform: translateX(100px) scale(0.8);z-index: 9;',
          'transform: translateX(170px) scale(0.5);z-index: 8;',
        ],
        // 当前轮播图索引号
        currentCarouselIndex: 0,
        // 自动滚动定时器
        autoRolling: null,
        autoRollingFlag: true,
      };
    },
    // 计算属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      // 计算变化之后的轮播图成员索引号
      computerIndex: function (id) {
        var arr = null;
        switch (id) {
          case 0:
            arr = [3, 4, 1, 2]
            break;
          case 1:
            arr = [4, 0, 2, 3]
            break;
          case 2:
            arr = [0, 1, 3, 4]
            break;
          case 3:
            arr = [1, 2, 4, 0]
            break;
          case 4:
            arr = [2, 3, 0, 1]
            break;
        }
        return arr;
      },
      // 非中间图片 才可以点击滚动
      rolling: function (e, id = null) {
        var _this = this;
        var item = document.querySelectorAll(".center div");
        if (e) {
          var id = Number(e.target.id);
          if (e.target.outerHTML.indexOf("z-index: 10;") == '-1') {
            _this.currentCarouselIndex = id;
            item[id].setAttribute('style', 'z-index: 10;');
            _this.computerIndex(id).forEach(function (ele, index) {
              item[ele].setAttribute('style', _this.styleArr[index])
            });
          }
        } else {
          if (_this.currentCarouselIndex != id) {
            _this.currentCarouselIndex = id;
            item[id].setAttribute('style', 'z-index: 10;');
            _this.computerIndex(id).forEach(function (ele, index) {
              item[ele].setAttribute('style', _this.styleArr[index])
            });
          }
        }
      },
      // 判断是PC端还是移动端
      IsPC: function () {
        // 当前设备信息
        let userAgentInfo = navigator.userAgent;
        let Agents = [
          "Android",
          "iPhone",
          "SymbianOS",
          "Windows Phone",
          "iPad",
          "iPod",
          "webOS",
          "BlackBerry"
        ];
        let flag = true;
        // 如果能匹配到上面的字符串 就说明是移动端
        for (let v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        };
        // true为PC端 false为移动端
        return flag;
      }
    },
    // 生命周期 - 创建完成 (可以访问当前this实例)
    created() {},
    // 生命周期 - 挂载完成 (可以访问DOM元素)
    mounted() {
      var _this = this;
      // 如果是移动端 直接跳转至手机下载页面
      if (!this.IsPC()) {
        this.$router.push('/download');
        return false;
      }
      // 生成二维码
      this.$nextTick(function () {
        _this.qrcode = new QRCode("qrcode", {
          width: 120,
          height: 120,
          text: "https://yyjrapp.com/#/download", // 二维码内容 也可以放url
          colorDark: "#000",
          colorLight: "#fff"
        });
      });
      // 自动轮播
      this.autoRolling = setInterval(() => {
        if (this.autoRollingFlag) {
          this.rolling(null, (this.currentCarouselIndex + 1) == 5 ? 0 : this.currentCarouselIndex + 1);
        }
      }, 5000);
    },
    // 生命周期 - 销毁之前
    beforeDestroy() {
      clearInterval(this.autoRolling);
      this.autoRolling = null;
    },
    // 生命周期 - 销毁完成
    destroyed() {},
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* @import url(路径); 引入公共css类 */
  /* font-family: SourceHanSansBold; */
  /* font-family: SourceHanSansRegular; */
  .box {
    background-color: #181818;
  }

  /* 头部 */
  .header {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    height: 60px;
    box-shadow: 0 0 10px 0 #ccc;
    background-color: #fff;
    z-index: 10000;
  }

  .headerContent {
    width: 960px;
    height: 60px;
    line-height: 60px;
    margin: 0 auto;
  }

  .headerContent .left {
    float: left;
    font-size: 20px;
  }

  .headerContent .left img {
    display: inline-block;
    border-radius: 10px;
    height: 40px;
    width: 40px;
    vertical-align: middle;
  }

  .headerContent .right {
    float: right;
  }

  .headerContent .right button {
    border: 1px solid #d6ced9;
    color: #5e5063;
    background-color: #fff;
    padding: 5px 15px;
    cursor: pointer;
  }

  /* 主体 */
  .main {
    padding-top: 60px;
  }

  /* 下载区域 */
  .main .download {
    width: 920px;
    height: 570px;
    margin: 20px auto 0 auto;
    background-color: #343434;
    border-radius: 10px;
    overflow: hidden;
    padding: 20px;
  }

  .main .download .leftImg {
    float: left;
    width: 300px;
    height: 100%;
    background-image: url(..\assets\img\2.2.png);
    margin-left: 50px;
    box-shadow: 0 0px 10px 10px #202020;
    border-radius: 50px;
    background-position: center;
    background-size: 100% 100%;
  }

  .main .download .text {
    float: right;
    width: 500px;
  }

  .main .download .text #qrcode {
    padding: 10px;
    background-color: #fff;
    border-radius: 10px;
    margin-bottom: 10px;
  }

  .main .download .downloadBox {
    height: 154px;
  }

  .main .download .downloadBox .downloadButton {
    margin-top: 40px;
  }

  .main .download .downloadBox .downloadButton button {
    display: block;
    border: 1px solid #d6ced9;
    color: #5e5063;
    background-color: #fff;
    padding: 5px 20px;
    cursor: pointer;
    border-radius: 20px;
    font-size: 16px;
  }

  /* 轮播图区域 */
  .main .carousel {
    position: relative;
    width: 900px;
    height: 530px;
    margin: 20px auto 0 auto;
    background-color: #343434;
    border-radius: 10px;
    overflow: hidden;
    padding: 30px 30px;
  }

  .main .carousel .center {
    width: 250px;
    height: 440px;
  }


  .main .carousel .left .actvie,
  .main .carousel .right .actvie {
    background-color: #535353;
    color: #eee;
  }

  .main .carousel .left div,
  .main .carousel .right div {
    cursor: pointer;
    padding: 10px;
    border-radius: 10px;
    color: #eee;
  }

  .main .carousel .left div p:nth-child(1),
  .main .carousel .right div p:nth-child(1) {
    font-weight: 600;
  }

  /* 轮播图 */
  .main .carousel .center {
    left: 50%;
    margin-left: -112px;
    position: absolute;
    width: 266px;
    height: 531px;
  }

  .main .carousel .center div {
    color: #fff;
    position: absolute;
    width: 266px;
    height: 531px;
    cursor: pointer;
    transition: all .5s;
    box-shadow: 0 0px 10px 3px #181818;
    border-radius: 40px;
    background-position: center;
    background-size: 102% 103%;
  }

  .main .carousel .center div:nth-child(1) {
    background-image: url(..\assets\img\1.1.png);
  }

  .main .carousel .center div:nth-child(2) {
    background-image: url(..\assets\img\2.2.png);
  }

  .main .carousel .center div:nth-child(3) {
    background-image: url(..\assets\img\3.3.png);
  }

  .main .carousel .center div:nth-child(4) {
    background-image: url(..\assets\img\4.4.png);
  }

  .main .carousel .center div:nth-child(5) {
    background-image: url(..\assets\img\5.5.png);
  }

  .main .carousel img {
    width: 100%;
    height: 100%;
  }

  /* 底部 */
  .food {
    padding: 20px 0;
    color: #b0aab3;
    text-align: center;
    font-size: 14px;
  }

  /* 小于 1024px 时的样式 */
  @media screen and (max-width: 1024px) {}
</style>


// WEBPACK FOOTER //
// src/components/index.vue